export function Welcome() {
  return (
    <div className="max-w-5xl mx-auto">
      {/* Title */}
      <h1 className="text-2xl font-bold text-slate-800 dark:text-white mb-8 text-center">
        CPAWS Terrestrial Conservation Study
      </h1>

      {/* Hero Image - Mountain/Waterfall landscape */}
      <div className="mb-8">
        <img
          src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%2Fid%2FOIP.qrvuz7Z8mpQgH-8A-2KQfAHaE8%3Fcb%3Ducfimg2%26pid%3DApi%26ucfimg%3D1&f=1&ipt=16040c6e9ecec50b027adf7c6b19453b750cfb45b56aed7d785d1de977822311"
          alt="Canadian mountain landscape with waterfall"
          className="w-full max-w-3xl mx-auto rounded-lg shadow-lg"
        />
      </div>

      {/* Methodology Section */}
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm p-8 mb-6">
        <h2 className="text-xl font-bold text-slate-800 dark:text-white mb-6">
          2025 CPAWS Public Opinion Research
        </h2>

        <div className="space-y-4 text-slate-600 dark:text-slate-300">
          <p>
            McAllister is an accredited member of ESOMAR, the international professional body
            for public opinion research and market intelligence.
          </p>

          <div className="border-t border-slate-200 dark:border-slate-600 pt-4">
            <h3 className="font-semibold text-slate-800 dark:text-white mb-3">METHODOLOGY</h3>
            <ul className="space-y-2 text-sm">
              <li>
                The survey was fielded online in both official languages across Canada between
                September and October 2025.
              </li>
              <li>
                <strong>Sample size:</strong> n=14,078
              </li>
              <li>
                Data was weighted by the latest census estimates for economic regions within
                each Canadian province, gender, age, and education.
              </li>
              <li>
                Randomized split sampling was used for language testing and to manage respondent burden.
              </li>
              <li>
                <strong>Margin of error:</strong> ±0.83%
              </li>
            </ul>
          </div>
        </div>

        {/* Link to Topline Report */}
        <div className="mt-6 pt-4 border-t border-slate-200 dark:border-slate-600">
          <p className="text-slate-600 dark:text-slate-300">
            Topline Report:{' '}
            <a
              href="https://drive.google.com/file/d/1GML4ZuDQ4eGlA5smorGJgmyFvRb3pwzR/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 dark:text-primary-400 hover:underline"
            >
              Click here to view the report
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
